// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1n0lF","consentsList":"PatientConsents_consentsList__34QjW","consentsListEmpty":"PatientConsents_consentsListEmpty__3Ndmc"};